import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'lib-scorecard-field',
    templateUrl: './scorecard-field.component.html',
    styleUrls: ['./scorecard-field.component.scss'],
    standalone: false
})
export class ScorecardFieldComponent {

  @Input() name: string;
  @Input() postfix: string;
  @Input() prefix: string;
  @Input() maxLength: number;
  @Input() decimalPoints: number;
  @Input() labelText: string;
  @Input() fullWidth: boolean = false;
  @Input() isBold: boolean = false;
  @Input() additionalValues: object = {};
  @Input() trackingIdPrefix: string;
  @Input() trackingIdPostfix: string;

  @Output() submitEvent = new EventEmitter();

  handleSubmit(event: Event): boolean {
    const thisForm: HTMLFormElement = event.target as HTMLFormElement;
    const formElements: HTMLFormControlsCollection = thisForm.elements;

    const sectionValues: object = Array.from(formElements)
      .filter((e: Element) => ((e as HTMLInputElement).type === 'radio' && !!(e as HTMLInputElement).checked) || ((e as HTMLInputElement).type !== 'radio'))
      .reduce((collection: object, elementEl: Element) => {
        const element = elementEl as HTMLInputElement;

        if (!!element.name) {
          return {
            ...collection,
            [element.name]: element.value,
          };
        }

        return collection;
      }, this.additionalValues);

    this.submitEvent.emit(sectionValues);

    return false;
  }

}
